// Libraries
import { Box, Flex } from '@chakra-ui/react';
import { ReactElement } from 'react';
// Components
import { DoubleCircleIcon, LocationMarkIcon } from '@atoms/Icons';
// Types
import { RouteWidgetProps } from './RouteWidget.type';

/**
 * Renders a RouteWidget component.
 *
 * @component
 * @param {boolean} vertical - Determines whether the layout of the component is vertical (true) or horizontal (false). Default is false.
 * @param {string} [length='auto'] - Specifies the length of the component. It accepts all values commonly used for width or height.
 * @returns {ReactElement} The rendered RouteWidget component.
 */
export const RouteWidget = ({ vertical, length = 'auto' }: RouteWidgetProps): ReactElement => {
  const dashedLineStyles = vertical
    ? {
        backgroundImage: 'linear-gradient(to bottom, #C1C1CF 30%, rgba(193,	193,	207, 0) 0%)',
        my: 1.5,
        w: '2px',
        backgroundSize: '2px 13px',
      }
    : {
        backgroundImage: 'linear-gradient(to right, #C1C1CF 30%, rgba(193,	193,	207, 0) 0%)',
        mx: 1.5,
        h: '2px',
        backgroundSize: '13px 2px',
      };

  return (
    <Flex
      w={!vertical ? length : 'auto'}
      h={vertical ? length : 'auto'}
      direction={vertical ? 'column' : 'row'}
      justify='space-between'
      align='center'
    >
      <LocationMarkIcon w={4} />
      <Box flex={1} backgroundRepeat='repeat' sx={dashedLineStyles} />
      <DoubleCircleIcon w={4} />
    </Flex>
  );
};
